var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00009 0.75C5.67717 0.75 5.35438 0.900483 5.1736 1.20132L0.129526 9.59281C-0.242167 10.2109 0.233397 11.0543 0.9549 11.0543H11.0442C11.7655 11.0543 12.2424 10.2109 11.8707 9.59281L6.82659 1.20132C6.64581 0.900483 6.32302 0.75 6.00009 0.75ZM6.00009 2.05134L10.7228 9.9075H1.27743L6.00009 2.05134ZM5.4267 4.17356V7.04053H6.57349V4.17356H5.4267ZM5.4267 8.18732V9.33411H6.57349V8.18732H5.4267Z",
    fill: "#FFAA15"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningMark);
export default __webpack_public_path__ + "static/media/warning-mark.745bf1a907da0162915df2d1b5112253.svg";
export { ForwardRef as ReactComponent };